"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectTextColor = exports.selectBackground = void 0;
var _styledComponents = require("styled-components");
var _constants = require("./constants");
// @ts-check

var selectTextColor = function selectTextColor(_ref) {
  var variant = _ref.variant;
  var theme = (0, _styledComponents.useTheme)();
  switch (variant) {
    case _constants.variants.blue:
      return theme.textColorVariantBlue;
    case _constants.variants.dark:
      return theme.textColorVariantDark;
    case _constants.variants.yellow:
      return theme.textColorVariantYellow;
    case _constants.variants.light:
    default:
      return theme.textColorVariantLight;
  }
};
exports.selectTextColor = selectTextColor;
var selectBackground = function selectBackground(_ref2) {
  var variant = _ref2.variant;
  var theme = (0, _styledComponents.useTheme)();
  switch (variant) {
    case _constants.variants.blue:
      return theme.backgroundVariantBlue;
    case _constants.variants.dark:
      return theme.backgroundVariantDark;
    case _constants.variants.yellow:
      return theme.backgroundVariantYellow;
    case _constants.variants.light:
    default:
      return theme.backgroundVariantLight;
  }
};
exports.selectBackground = selectBackground;